import { z } from 'zod';
import { searchQuerySchema } from '../search/contracts';

export const todayStates = ['not_assessed', 'available', 'awaiting_decision', 'scheduled', 'running', 'verifying', 'reboot_required', 'failed', 'verified_complete', 'reported_success'] as const;
export const todayCategories = ['assessment', 'availability', 'protection', 'repair', 'os_quality', 'os_feature', 'cached_software', 'installed_app', 'optional_app', 'driver', 'protection_agent', 'agent', 'ticket'] as const;
export type TodayState = typeof todayStates[number];
export type TodayCategory = typeof todayCategories[number];
export const todayQuerySchema = z.object({
  scope: searchQuerySchema.refine(q => q.kinds.length === 1 && q.kinds[0] === 'device', 'Today scope requires devices').default(() => searchQuerySchema.parse({ kinds: ['device'] })),
  state: z.enum(todayStates).optional(), category: z.enum(todayCategories).optional(),
  limit: z.number().int().min(1).max(100).default(25), offset: z.number().int().min(0).max(10000).default(0),
}).strict();
export type TodayQuery = z.infer<typeof todayQuerySchema>;
export interface TodayItem {
  id: string; title: string; state: TodayState; category: TodayCategory;
  organizationId: string | null; customer: string | null; siteId: string | null; site: string | null; deviceId: string | null; device: string | null;
  owner: string | null; reason: string; nextAction: string; dueAt: string | null; observedAt: string | null;
  target: { kind: 'device' | 'job' | 'ticket'; id: string; tab?: string };
}
export interface TodayView {
  computedAt: string; since: string; coverage: { totalDevices: number; freshDevices: number }; partial: boolean;
  counts: Record<TodayState, number>; digest: { verifiedComplete: number; reportedSuccess: number };
  total: number; items: TodayItem[]; limitations: string[];
  sources: Array<{ category: TodayCategory; state: 'available' | 'not_assessed'; detail: string }>;
}
